export default "__VITE_ASSET__B98wP8jA__"